<script setup lang="ts">
import { onMounted } from 'vue'

import { useUrlHelper } from '../../composables/use-url-helper'
import { useAdaPagestrip } from '../../composables/use-ada-pagestrip'

const { getQueryParams } = useUrlHelper()
const { pagestripQuery, initPagestrip } = useAdaPagestrip()

onMounted(() => {
  pagestripQuery.value = getQueryParams()?.ps ?? null
  initPagestrip()
})
</script>

<template>
  <div class="bx-content bx-ada-pagestrip">
    <div id="pagestrip-header" />
    <div id="pagestrip-main" />
  </div>
</template>
